import { Typography, Button } from "@mui/material";

import { SiGooglescholar } from "react-icons/si";
import {
    AiFillMail,
    AiFillGithub,
    AiFillLinkedin,
    AiFillFacebook,
} from "react-icons/ai";

export default function Footer() {
    return <div id="contact" className="Footer">
        <Typography variant="h2">CONTACT</Typography>
        <div className="Social">
                <Button
                    href="mailto:atickfaisal@gmail.com"
                >
                    <AiFillMail className="icon" />
                </Button>
                <Button
                    href="https://github.com/atick-faisal/"
                >
                    <AiFillGithub className="icon" />
                </Button>
                <Button
                    href="https://linkedin.com/in/atick-faisal/"
                >
                    <AiFillLinkedin className="icon" />
                </Button>
                <Button
                    href="https://scholar.google.com/citations?user=ZiPKjAgAAAAJ&hl=en/"
                >
                    <SiGooglescholar className="icon" />
                </Button>
                <Button
                    href="https://www.facebook.com/atick.faisal.52"
                >
                    <AiFillFacebook className="icon" />
                </Button>
            </div>
    </div>
}